<template>
  <div class="fill-height of-y">
    <v-scroll-y-transition hide-on-leave>
      <div key="loading" class="fill-height d-flex justify-center align-center" v-if="loadingLeave">
        <v-progress-circular
          v-if="true"
          :size="40"
          :width="2"
          color="primary"
          indeterminate
        />
      </div>
      <div key="calendar" class="fill-height of-y px-2 pb-2" v-if="!loadingLeave && $store.state.ref.leave.tabIndex === 0">

        <v-card class="fill-height">
          <v-calendar
            ref="calendar"
            v-model="model"
            :type="viewType"
            color="primary"
            event-start="start"
            event-end="end"
            :event-name="getEventName"
            :event-color="getEventColor"
            :events="leaveRecords"
            @click:more="viewMore"
            @click:date="dateClicked"
            @click:event="eventClicked"
          ></v-calendar>
        </v-card>



      </div>

      <div key="table" class="fill-height of-y px-2 pb-2" v-if="!loadingLeave && $store.state.ref.leave.tabIndex === 1">
        <v-card class="fill-height of-y">
          <v-data-table
            ref="table"
            :headers="headers"
            :items="viewLeaveRecords"
            :search="$store.state.ref.leave.filterStr"
            :items-per-page="leaveRecords.length"
            hide-default-footer
            fixed-header
            class="fill-height of-y full-table"
            item-key="_id"
          >


            <!--                        <template v-slot:item.employeeId="{ item }">-->
            <!--                            {{employeesRef[item.employeeId].name}}-->
            <!--                        </template>-->

            <template v-slot:item.start="{ item }">
              {{format(item.start, 'dd MMM yyyy')}}
            </template>

            <template v-slot:item.end="{ item }">
              {{format(item.end, 'dd MMM yyyy')}}
            </template>

            <!--                        <template v-slot:item.addedBy="{ item }">-->
            <!--                            {{usersRef[item.addedBy].name}}-->
            <!--                        </template>-->

            <template v-slot:item.createdAt="{ item }">
              {{format(new Date(item.createdAt), 'dd MMM yyyy HH:mm')}}
            </template>


            <!--Actions-->
            <template v-slot:item.actions="{ item }">
              <v-btn
                style="overflow: hidden !important;"
                class="mr-1 allOverflowHidden"
                @click="viewEvent = item"
                icon
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <!--                    <template v-slot:item.employeeName="{ item }">-->
            <!--                        <div class="d-flex align-center overline" style="white-space: nowrap">-->
            <!--                            <v-icon left small>mdi-account</v-icon>-->
            <!--                            {{ item.employeeName }}-->
            <!--                        </div>-->
            <!--                    </template>-->
            <!--                    <template v-slot:item.teamName="{ item }">-->
            <!--                        <v-btn-->
            <!--                            small-->
            <!--                            text-->
            <!--                            color="primary"-->
            <!--                            @click.stop="gotoTeam(item.teamId)"-->
            <!--                        >-->
            <!--                            <v-icon left>mdi-account-group</v-icon>-->
            <!--                            {{ item.teamName }}-->
            <!--                        </v-btn>-->
            <!--                    </template>-->
            <!--                    <template v-slot:item.workTime="{ item }">{{ hoursDisplay(item.workTime, true) }}</template>-->
            <!--                    <template v-slot:item.activeTime="{ item }">{{ hoursDisplay(item.activeTime, true) }}</template>-->

            <!--                    &lt;!&ndash;                        <template v-slot:header.activeTime="{header}">&ndash;&gt;-->
            <!--                    &lt;!&ndash;                            <div class="b1" style="width: 150px">&ndash;&gt;-->
            <!--                    &lt;!&ndash;                                {{header.text}}123456&ndash;&gt;-->
            <!--                    &lt;!&ndash;                            </div>&ndash;&gt;-->
            <!--                    &lt;!&ndash;                        </template>&ndash;&gt;-->

            <!--                    <template v-slot:item.ptt="{ item }">{{ hoursDisplay(item.ptt, true) }}</template>-->
            <!--                    <template v-slot:item.ptn="{ item }">{{ hoursDisplay(item.ptn, true) }}</template>-->
            <!--                    <template v-slot:item.pto="{ item }">{{ hoursDisplay(item.pto, true) }}</template>-->
            <!--                    <template v-slot:item.utt="{ item }">{{ hoursDisplay(item.utt, true) }}</template>-->
            <!--                    <template v-slot:item.utn="{ item }">{{ hoursDisplay(item.utn, true) }}</template>-->
            <!--                    <template v-slot:item.uto="{ item }">{{ hoursDisplay(item.uto, true) }}</template>-->
            <!--                    <template v-slot:item.ntt="{ item }">{{ hoursDisplay(item.ntt, true) }}</template>-->
            <!--                    <template v-slot:item.ntn="{ item }">{{ hoursDisplay(item.ntn, true) }}</template>-->
            <!--                    <template v-slot:item.nto="{ item }">{{ hoursDisplay(item.nto, true) }}</template>-->
            <!--                    <template v-slot:item.ttt="{ item }">{{ hoursDisplay(item.ttt, true) }}</template>-->
            <!--                    <template v-slot:item.idleTime="{ item }">{{ hoursDisplay(item.idleTime, true) }}</template>-->
            <!--                    <template v-slot:item.productivityTarget="{ item }">{{ percentDisplay(item.productivityTarget) }}</template>-->
            <!--                    <template v-slot:item.productivityNormalTarget="{ item }">{{ percentDisplay(item.productivityNormalTarget) }}</template>-->
            <!--                    <template v-slot:item.productivityActive="{ item }">{{ percentDisplay(item.productivityActive) }}</template>-->
            <!--                    <template v-slot:item.productivityWorkTime="{ item }">{{ percentDisplay(item.productivityWorkTime) }}</template>-->
            <!--                    <template v-slot:item.actions="{ item }">-->
            <!--                        <v-btn-->
            <!--                            color="primary"-->
            <!--                            class="mx-2"-->
            <!--                            small-->
            <!--                            icon-->
            <!--                            @click.stop="gotoEmployeeSettings(item._id)"-->
            <!--                        >-->
            <!--                            <v-icon>mdi-cog</v-icon>-->
            <!--                        </v-btn>-->
            <!--                    </template>-->
          </v-data-table>
        </v-card>
      </div>
    </v-scroll-y-transition>

    <app-dlg
      v-if="viewEvent"
      :show-dlg.sync="viewEventRelay"
      title="Leave Record"
    >
      <template>
        <v-autocomplete
          v-model="viewEvent.addedBy"
          :items="addedByUsersModified"
          item-text="name"
          item-value="_id"
          prepend-icon="mdi-badge-account"
          label="Added by"
          color="primary"
          outlined
          dense
          readonly
        >
        </v-autocomplete>

        <v-text-field
          :value="format(new Date(viewEvent.createdAt), 'dd MMMM yyyy HH:mm')"
          outlined
          prepend-icon="mdi-calendar-plus"
          label="Added"
          color="primary"
          dense
          readonly
        >
        </v-text-field>

        <v-autocomplete
          v-model="viewEvent.employeeId"
          :items="employees"
          item-text="name"
          item-value="_id"
          prepend-icon="mdi-account"
          label="Employee"
          color="primary"
          outlined
          dense
          readonly
        >
        </v-autocomplete>

        <v-text-field
          :value="format(viewEvent.start, 'dd MMMM yyyy')"
          outlined
          prepend-icon="mdi-calendar-start"
          label="First day off"
          color="primary"
          dense
          readonly
        />

        <v-text-field
          :value="format(viewEvent.end, 'dd MMMM yyyy')"
          outlined
          prepend-icon="mdi-calendar-end"
          label="Last day off"
          color="primary"
          dense
          readonly
        >
        </v-text-field>

      </template>

      <template v-slot:actions>
        <v-btn
          class="ml-2"
          small
          color="error"
          @click="removeLeaveRecord"
          outlined
          size="small"
          :disabled="removingLeaveRecord"
          :loading="removingLeaveRecord"
        >
          Delete Record
        </v-btn>

        <v-btn
          @click="viewEvent = null"
          small
          class="ml-2"
          color="primary"
          :disabled="removingLeaveRecord"
        >
          Done
        </v-btn>
      </template>
    </app-dlg>

    <app-add-leave-dlg
      :shown.sync="$store.state.ref.leave.showAdd"
      :preset-start="presetAddStart"
      @input="recordAdded"
    />

  </div>
</template>

<script>

import {percentDisplay, hourDisplay, exportStats, objectifyArr, durationDisplay, arrSplice} from "@/core/codeFunctions";
import AppDlg from "@/components/Shared/AppDlg";
import AppList from "@/components/Shared/AppList/AppList";
import {mapActions, mapGetters} from "vuex";
import {endOfMonth, format, isSameDay, isSameMonth, isSameYear, startOfMonth, startOfWeek} from "date-fns";
import AppAddLeaveDlg from "@/components/Leave/AppAddLeaveDlg.vue";
import {getColor} from "random-material-color";

export default {
  components: {AppAddLeaveDlg, AppList, AppDlg},
  props: {
    vm: Object
  },
  data() {
    return {
      format,
      hoursDisplay: hourDisplay,
      percentDisplay: percentDisplay,
      loading: false,
      stats: [],
      headers: [
        {text: 'Employee', value: 'employeeName'},
        {text: 'Start', value: 'start'},
        {text: 'End', value: 'end'},
        {text: 'Added By', value: 'addedByName'},
        {text: 'Added', value: 'createdAt'},
        {value: 'actions', align: 'end', width: 50},
      ],
      selectedManuals: [],
      loadingItems: [],
      loadingLeave: false,
      leaveRecords: [],
      presetAddStart: new Date(),

      model: new Date(),
      viewType: "month",
      viewEvent: null,
      removingLeaveRecord: false
    }
  },
  mounted() {
    // this.refreshData();
  },

  watch: {
    "$store.state.ref.leave.leaveDate": {
      immediate: true,
      handler(val) {
        this.model = new Date(val)
        this.viewType = 'month'
        this.presetAddStart = this.$store.state.ref.leave.leaveDate
        this.refreshLeave()
      }
    },

  },

  methods: {
    ...mapActions(["gotoEmployee", "gotoEmployeeSettings", "gotoTeam", "updateSelections"]),

    async removeLeaveRecord() {
      try {
        this.removingLeaveRecord = true
        await this.$newReq('POST', 'leave/remove', {_id: this.viewEvent._id})
        arrSplice(this.leaveRecords, rec => rec._id === this.viewEvent._id)
        this.viewEvent = null
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
      } finally {
        this.removingLeaveRecord = false
      }
    },

    eventClicked(event) {
      this.viewEvent = event.event
    },
    recordAdded(record) {
      record.start = new Date(record.start)
      record.end = new Date(record.end)
      this.leaveRecords.push(record)
    },

    dateClicked(event) {
      this.presetAddStart = new Date(event.date)
      this.$store.state.ref.leave.showAdd = true
    },

    viewMore (event) {
      this.model = event.date
      this.viewType = 'week'
    },

    getEventName(item) {
      return this.employeesRef[item.input.employeeId] ? this.employeesRef[item.input.employeeId].name : "No Employee"
    },
    getEventColor(item) {
      return this.employeesRef[item.employeeId] ? getColor({ text: this.employeesRef[item.employeeId].name }) : "No Employee"
    },

    async refreshLeave() {
      try {
        this.loadingLeave = true
        const {leaveRecords} = await this.$newReq('POST', 'leave/monthView', {start: startOfMonth(this.$store.state.ref.leave.leaveDate), end: endOfMonth(this.$store.state.ref.leave.leaveDate)})
        this.leaveRecords = leaveRecords.map(rec => {
          rec.start = new Date(rec.start)
          rec.end = new Date(rec.end)
          return rec
        })
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
      } finally {
        this.loadingLeave = false
      }
    }



  },
  computed: {
    ...mapGetters(['employees', 'employeesRef', "usersRef", 'users', 'access', 'devicesWithAccess', 'approvalsWithAccess', 'employeesRef', 'teamsRef', 'labelsRef', 'statusmaps', 'statusmapsRef', 'employeesWithAccessIds']),

    viewLeaveRecords() {
      return this.leaveRecords.map(val => {
        return {
          ...val,
          employeeName: this.employeesRef[val.employeeId].name,
          addedByName: this.usersRef[val.addedBy].name
        }
      })
    },

    viewEventRelay: {
      get() {
        return !!this.viewEvent
      },
      set(val) {
        this.viewEvent = null
      }
    },

    manualTimeByMatch() {
      return objectifyArr(this.statusmaps.filter(st => st.manualTime), 'match')
    },

    addedByUsersModified() {
      const usersRef = this.users;

      usersRef.push({
        name: 'API',
        _id: null
      })

      return usersRef;
    },

    viewItems() {
      return this.approvalsWithAccess.map(app => {

        try {
          app.employee = this.employeesRef[app.employeeId]
          app.employeeName = app.employee.name

          app.team = this.teamsRef[app.employee.teamId]
          app.teamName = app.team.name

          app.labelId = 0;

          if (typeof app.start === "string")
            app.start = new Date();

          if (typeof app.end === "string")
            app.end = new Date();


          const stMap = this.manualTimeByMatch[app.match]

          if (stMap) {
            app.labelId = stMap.defaultLabel
            if (stMap.teamLabels.length) {
              const teamSt = stMap.teamLabels.find(teamStObj => teamStObj.teamId === app.team._id)
              if (teamSt)
                app.labelId = teamSt.label
            }
          }
          app.label = this.labelsRef[app.labelId]
        } catch (e) {
          console.log(e)
        }
        return app
      })
    }
  },
}
</script>

<style>

.v-calendar-daily__body {
  display: none;
}

.v-calendar-daily__head {
  height: 100%;
}

.allOverflowHidden * {
  overflow: hidden !important;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  height: unset !important;
}

</style>